export const PAGE_API = 'pageApi';
export const REFRESH_PAGE_API = 'refreshPageApi';
export const SHOW_COMPONENT_PAGE_API = 'showComponentPageApi';
export const HIDE_COMPONENT_PAGE_API = 'hideComponentPageApi';
export const USER_ROLE_API = 'userRoleApi';
export const EMAIL_TEMPLATE_API = 'emailTemplateApi';
export const PAGE_COMPONENT = 'pageComponent';
export const REFRESH_PAGE_COMPONENT = 'refreshPageComponent';
export const RESET_PASSWORD_PAGE_COMPONENT = 'resetPassowordPageComponent';
export const PAGE_FORM_COMPONENT = 'pageFormComponent';
export const PAGE_FORM_COMPONENTS = 'pageFormComponents';
export const SHOW_PAGE_COMPONENTS = 'showPageComponents';
export const HIDE_PAGE_COMPONENTS = 'hidePageComponents';
export const MODAL_API = 'modalApi';
export const SUB_PAGE_API = 'subPageApi';
export const PDF_TEMPLATE_API = 'pdfTemplateApi';
export const PAGE_SUB_PAGE_COMPONENTS_API = 'pageSubPageComponentApi';
export const CUSTOM_COMPONENT_API = 'customComponentApi';
export const SOURCE_API = 'sourceApi';
export const SOURCE_PAGE = 'sourcePage';
export const SOURCE_PAGE_API = 'sourcePageApi';
export const PAGE_CUSTOM_COMPONENT_COMPONENTS_API = 'pageCustomComponentComponentApi';
export const DS_REST_API = 'dsRestApi';
export const DS_DATABASE = 'dsDatabase';
export const DS_GOOGLE_SHEET = 'dsGoogleSheet';
export const DS_AIRTABLE = 'dsAirtable';
export const DS_FIREBASE_CLOUD_FIRESTOE = 'dsFirebaseCloudFirestore';
export const DS_FIREBASE_FUNCTION = 'dsFirebaseFunction';
export const DS_FIREBASE_REALTIME_DATABASE = 'dsFirebaseRealtimeDatabase';
export const DS_EXTERNAL_API = 'dsExternalApi';
export const DS_ZAPS = 'dsZaps';
export const DS_CHAT_GPT = 'dsChatGPT';
export const DS_SUPABASE = 'dsSupabase';
export const DS_DIRECTUS = 'dsDirectus';
export const DS_APPWRITE = 'dsAppwrite';
export const DS_XANO = 'dsXano';
export const DS_API_COLLECTION_FIELDS = 'dsApiCollectionFields';
export const COLLECTION_API = 'collectionApi';
export const COLLECTION_CONSTRUCTOR_API = 'collectionConstructorApi';
export const TENANT_CONSTRUCTOR_API = 'tenantConstructorApi';
export const COLLECTION_REQUEST_API = 'collectionRequestApi';
export const WAIT_TIME_OPTIONS_IN_SECOND = 'waitTimeOptionsInSecond';
export const COLLECTION_FIELD_API = 'collectionFieldApi';
export const REDIRECT_FROM_OPTIONS = 'redirectFromOptions';
export const PAGE_COLLECTION_FORM_COMPONENT = 'pageCollectionFormComponent';
export const REFRESH_PAGE = 'refreshPage';
export const SHOW_COMPONENT_PAGE = 'showComponentPage';
export const COMPONENT_PAGE = 'componentPage';
export const HIDE_COMPONENT_PAGE = 'hideComponentPage';
export const PAGE = 'page';
export const FORM_PAGE = 'formPage';
export const DEFAULT_USER_COLLECTION = 'user';
export const LOCALIZATION_API = 'localizationApi';
export const MULTI_TENANT_API = 'multiTenantApi';
export const TOOLTIP_API = 'toolTipApi';
export const TOOLTIP_POSITION = 'toolTipPosition';
export const TOOLTIPS_THEME = 'toolTipTheme';
export const TOOLTIPS_ANIMATION = 'toolTipAnimation';
export const TOOLTIPS_FOLLOW_CURSOR = 'toolTipFollowCursor';
export const SMS_TEMPLATE_API = 'smsTemplateApi';
export const description = `Go to the Delete Permissions in Settings and Enable it.`;
export const AGREEMENT_TEMPLATE_API = 'agreementTemplateApi';
export const AGREEMENT_TEMPLATE_PDF_API = 'agreementTemplatePdfApi';
export const TYPESENSE_SEARCH_COLLECTION_API = 'typesenseSearchCollectionApi';
export const GET_CUSTOM_FUNCTION_FROM_API = 'getCustomFunctionFromApi';
export const EMAIL_SERVICE_PLUGIN_API = 'emailServicePluginApi';
export const COLLECTION_META_DATA_MAPPING_API = 'collectionMetaDataMappingApi';
export const GET_ITEM_ID_FROM_API = 'getItemIdFromApi';

export const waitTimeOptions = [
  { value: '', label: '-Select One-' },
  { value: 5, label: '5 Seconds' },
  { value: 10, label: '10 Seconds' },
  { value: 15, label: '15 Seconds' },
  { value: 30, label: '30 Seconds' },
  { value: 45, label: '45 Seconds' },
  { value: 60, label: '1 Minute' },
];

export const redirectOptions = [
  { value: 'SESSION', label: 'Session Value (Previous Action Response)' },
  { value: 'CUSTOM_URL', label: 'Custom URL' },
  { value: 'FORM_SUBMIT_SESSION_VALUE', label: 'Form Submit Through Session Value' },
  {
    value: 'BASE64_FORM_SUBMIT_SESSION_VALUE',
    label: 'Base64 Form Submit Through Session Value',
  },
  { value: 'BROWSER_STORAGE', label: 'Browser Storage' },
];

export const refreshShowHideOpts = [COMPONENT_PAGE, PAGE, FORM_PAGE, SHOW_COMPONENT_PAGE_API];

export const dropdownSourceOpts = [
  PAGE,
  FORM_PAGE,
  SOURCE_PAGE_API,
  SHOW_COMPONENT_PAGE,
  HIDE_COMPONENT_PAGE,
  SHOW_COMPONENT_PAGE_API,
  HIDE_COMPONENT_PAGE_API,
  REFRESH_PAGE,
  REFRESH_PAGE_API,
];

export const collectionRequestOptions = [
  { value: 'Secured', label: 'Secured (LoggedIn User)' },
  { value: 'Open', label: 'Open (Non-LoggedIn User)' },
];

export const sendDataToApiOptions = [
  'sendDataToExternalApi',
  'sendDataToExternalApiAndAuthorize',
  'sendDataToExternalApiAndFileDownload',
];

export const sourceOptions = [
  { value: 'PAGE', label: 'Page' },
  { value: 'MODAL', label: 'Modal' },
  { value: 'SUB_PAGE', label: 'Sub Page' },
];

export const toolTipPositionOptions = [
  { value: 'top', label: 'Top' },
  { value: 'top-start', label: 'Top Start' },
  { value: 'top-end', label: 'Top End' },
  { value: 'right', label: 'Right' },
  { value: 'right-start', label: 'Right Start' },
  { value: 'right-end', label: 'Right End' },
  { value: 'bottom', label: 'Bottom' },
  { value: 'bottom-start', label: 'Bottom Start' },
  { value: 'bottom-end', label: 'Bottom End' },
  { value: 'left', label: 'Left' },
  { value: 'left-start', label: 'Left Start' },
  { value: 'left-end', label: 'Left End' },
  { value: 'auto', label: 'Auto' },
  { value: 'auto-start', label: 'Auto Start' },
  { value: 'auto-end', label: 'Auto End' },
];

export const toolTipsThemeOptions = [
  { value: 'light', label: 'Light' },
  { value: 'light-border', label: 'Light Border' },
  { value: 'material', label: 'Material' },
  { value: 'translucent', label: 'Translucent' },
];

export const toolTipsAnimationOptions = [
  { value: 'shift-away', label: 'Shift Away' },
  { value: 'shift-away-subtle', label: 'Shift Away Subtle' },
  { value: 'shift-away-extreme', label: 'Shift Away Extreme' },
  { value: 'shift-toward', label: 'Shift Toward' },
  { value: 'shift-toward-subtle', label: 'Shift Toward Subtle' },
  { value: 'shift-toward-extreme', label: 'Shift Toward Extreme' },
  { value: 'scale', label: 'Scale' },
  { value: 'scale-subtle', label: 'Scale Subtle' },
  { value: 'scale-extreme', label: 'Scale Extreme' },
  { value: 'perspective', label: 'Perspective' },
  { value: 'perspective-subtle', label: 'Perspective Subtle' },
  { value: 'perspective-extreme', label: 'Perspective Extreme' },
];

export const toolTipsFollowCursorOptions = [
  { value: false, label: 'False' },
  { value: 'horizontal', label: 'Horizontal' },
  { value: 'vertical', label: 'Vertical' },
  { value: true, label: 'Both' },
  { value: 'initial', label: 'Initial' },
];

export const getItemIdFromOptions = [
  { value: '', label: '- Select One -' },
  { value: 'default', label: `Current Item ID (Default).` },
  { value: 'sendPreviousStepParentCollectionId', label: `Item ID from Previous Step.` },
  { value: 'sendCurrentPageItemId', label: `Item ID of Current Page.` },
  {
    value: 'sendBSLItemId',
    label: `Item ID from Browser Storage Location.`,
  },
];
